import { connect } from 'react-redux';
import { withRouter, Route } from 'react-router-dom';
import { withAuth } from 'components/provider/Auth';
import LoginRedirect from '../LoginRedirect';
import NotFound from 'components/route/NotFound';
import PaddedPage from 'components/shared/PaddedPage';
import PropTypes from 'prop-types';
import React from 'react';

const StaffOrSponsorRoute = ({
  account,
  component: TheComponent,
  render,
  ...props
}) => {
  return (
    <Route
      {...props}
      render={props => {
        if (typeof account === 'undefined') return <PaddedPage {...props} />;
        if (account === null) return <LoginRedirect {...props} />;
        if (!account?.data?.isStaff && !account?.data?.isSponsor) return <NotFound {...props} />;
        return render ? render(props) : <TheComponent {...props} />;
      }}
    />
  );
};

StaffOrSponsorRoute.contextTypes = {
  component: PropTypes.object
};

export default withRouter(
  withAuth(
    connect()(StaffOrSponsorRoute)
  )
);
